import HTTP from '../http';

export default {
  namespaced: true,
  state: {
    isFetchingCategories: true,
    categories: [],
    itemsMenuBar: [],
  },
  actions: {
    fetchCategories({ commit }) {
      return HTTP().get('/categories')
        .then(({ data }) => {
          commit('setCategories', data);
        });
    },
  },
  getters: {

  },
  mutations: {
    setCategories(state, categories) {
      state.categories = categories;
      state.itemsMenuBar = categories.map((category) => ({
        label: category.name,
        icon: 'pi pi-fw pi-home',
        items: category.subcategories.map((subcategory) => ({
          label: subcategory.name,
          to: `/properties/${subcategory.id}`,
        })),
      }));
      state.isFetchingCategories = false;
    },
  },
};
